var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2700,
    height: 960,
    viewBox: "0 0 2700 960",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "m") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1979.69,101.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V110.82s0-9.32-8.29-9.32Z",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1979.69,700.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V709.82s0-9.32-8.29-9.32Z",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M609.69,417.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V426.82s0-9.32-8.29-9.32Z",
    opacity: 0.02
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M469.69,109.84s-8.29,0-8.29,9.33v81.35s0,9.32,8.29,9.32h83.42s8.29,0,8.29-9.32V119.17s0-9.33-8.29-9.33Z",
    opacity: 0.07
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M819.69,417.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V426.82s0-9.32-8.29-9.32Z",
    opacity: 0.08
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M919.69,317.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V326.82s0-9.32-8.29-9.32Z",
    opacity: 0.06
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M519.69,717.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V726.82s0-9.32-8.29-9.32Z",
    opacity: 0.05
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2279.69,200.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V209.82s0-9.32-8.29-9.32Z",
    opacity: 0.04
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2379.69,300.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V309.82s0-9.32-8.29-9.32Z",
    opacity: 0.04
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1679.69,301.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V310.82s0-9.32-8.29-9.32Z",
    opacity: 0.04
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M469.69,528.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V537.82s0-9.32-8.29-9.32Z",
    opacity: 0.04
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M257.69,199.65s-8.29,0-8.29,9.33v81.35s0,9.32,8.29,9.32h83.42s8.29,0,8.29-9.32V209s0-9.33-8.29-9.33Z",
    stroke: "#004e95",
    opacity: 0.04
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.69,716.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V725.82s0-9.32-8.29-9.32Z",
    opacity: 0.02
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1920.69,450.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V459.82s0-9.32-8.29-9.32Z",
    fill: "#fff",
    opacity: 0.01
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2279.69,600.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V609.82s0-9.32-8.29-9.32Z",
    fill: "#fff",
    opacity: 0.01
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M712.8,317.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V326.82s0-9.32-8.29-9.32Z",
    fill: "#fff",
    opacity: 0.01
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M277.69,616.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V625.82s0-9.32-8.29-9.32Z",
    fill: "#fff",
    opacity: 0.01
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2179.69,300.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V309.82s0-9.32-8.29-9.32Z",
    fill: "#fff",
    opacity: 0.02
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2079.69,600.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V609.82s0-9.32-8.29-9.32Z",
    fill: "#fff",
    opacity: 0.02
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1779.69,599.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V608.82s0-9.32-8.29-9.32Z",
    fill: "#fff",
    opacity: 0.02
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M509.69,317.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V326.82s0-9.32-8.29-9.32Z",
    fill: "#fff",
    opacity: 0.06
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M719.69,517.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V526.82s0-9.32-8.29-9.32Z",
    fill: "#fff",
    opacity: 0.02
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M2279.69,400.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V409.82s0-9.32-8.29-9.32Z",
    fill: "#fff",
    opacity: 0.03
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M2179.69,100.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V109.82s0-9.32-8.29-9.32Z",
    fill: "#fff",
    opacity: 0.08
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1979.69,300.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V309.82s0-9.32-8.29-9.32Z",
    fill: "#fff",
    opacity: 0.08
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2479.69,699.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V708.82s0-9.32-8.29-9.32Z",
    fill: "#fff",
    opacity: 0.08
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M819.69,17.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V26.82s0-9.32-8.29-9.32Z",
    fill: "#fff",
    opacity: 0.04
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M819.69,217.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V226.82s0-9.32-8.29-9.32Z",
    fill: "#fff",
    opacity: 0.06
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M819.69,617.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V626.82s0-9.32-8.29-9.32Z",
    fill: "#fff",
    opacity: 0.04
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M357.69,409.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V418.82s0-9.32-8.29-9.32Z",
    fill: "#fff",
    opacity: 0.04
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M2079.69,400.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V409.82s0-9.32-8.29-9.32Z",
    fill: "#fff",
    opacity: 0.08
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1779.69,201.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V210.82s0-9.32-8.29-9.32Z",
    fill: "#fff",
    opacity: 0.1
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M659.69,109.84s-8.29,0-8.29,9.33v81.35s0,9.32,8.29,9.32h83.42s8.29,0,8.29-9.32V119.17s0-9.33-8.29-9.33Z",
    fill: "#fff",
    opacity: 0.1
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M619.69,617.5s-8.29,0-8.29,9.32v81.35s0,9.33,8.29,9.33h83.42s8.29,0,8.29-9.33V626.82s0-9.32-8.29-9.32Z",
    fill: "#fff",
    opacity: 0.06
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgGrid);
export default __webpack_public_path__ + "static/media/bg-grid.97cba7286e66b656bde281eda5f37dcb.svg";
export { ForwardRef as ReactComponent };